module.exports = __webpack_public_path__ + "static/media/logo.eb3b69c2.png";